import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsbEnum } from "@/utils/indicatorsEsb";
import { ResumeIndicatorB2Data } from "@/services/esus/indicator/esb/b2/getResumeIndicatorB2";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsbB2ResumeProps = {
	resume: ResumeIndicatorB2Data;
};

export function IndicatorEsbB2Resume({ resume }: Readonly<IndicatorEsbB2ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalCitizensFinished,
		resume.totalCitizens
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos com consulta programada"
					value={resume.totalCitizens.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos com consulta programada"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos com primeira consulta programada realizada{" "}
								<br />
								nos últimos 12 meses anteriores ao período atual. <br />
								Obs: em casos onde 1 cidadão tenha realizado consulta programada{" "}
								<br />
								por mais de 1 equipe, ambas as equipes irão contabilizar para o{" "}
								<br />
								indicador
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos com tratamento concluído"
					value={resume.totalCitizensFinished.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos com tratamento concluído"
							message="Quantidade de cidadãos com tratamento concluído no período atual"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos com tratamento concluído no período
								atual. <br />
								Obs: em casos onde 1 cidadão tenha realizado tratamento por mais de
								1 <br />
								equipe, ambas as equipes irão contabilizar para o indicador <br />
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos com tratamento pendente"
					value={(resume.totalCitizens - resume.totalCitizensFinished).toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos com tratamento pendente"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos que tiveram a primeira consulta programada
								nos <br />
								últimos 12 meses anteriores ao período atual e que não
								concluíram <br />
								o tratamento no período atual (A portaria indica que seja
								informado <br />
								no atendimento a opção "Tratamento concluído" para que o tratamento
								seja <br />
								considerado como concluído). <br />
								Obs: em casos onde 1 cidadão tenha realizado tratamento por mais de
								1 <br />
								equipe, ambas as equipes irão contabilizar para o indicador <br />
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsbEnum.B2,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de cidadãos com tratamentos concluídos no período
								atual em relação <br />
								aos cidadãos com consulta programada nos 12 meses anteriores ao
								período atual <br />
								que não possuam finalização de tratamento em período anterior.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
